import { blue, grey } from '@material-ui/core/colors';
import { createMuiTheme, Theme as MUITheme } from '@material-ui/core';
import personalAgreementBg from '../static/images/personal-agreement-bg.png';
import { BrandsEnum } from '../surveyCollector/SurveyCollector';

const mainColor = '#001E50';

const { spacing } = createMuiTheme();

const myGreen = {
  ...blue,
  '500': mainColor,
  '600': mainColor,
  A100: mainColor,
  A200: mainColor,
  A400: mainColor,
  A700: mainColor,
};

const fontFamily = '"VW", "Helvetica Neue", Helvetica, Arial, sans-serif';

const theme = {
  palette: {
    primary: myGreen,
    secondary: {
      light: grey.A100,
      main: '#00B0F0',
      dark: grey.A400,
      contrastText: '#ffffff',
    },
    background: {
      default: 'ffffff',
    },
  },
  typography: {
    fontFamily: fontFamily,
    useNextVariants: true,
  },
  screenElement: {
    sidePadding: spacing(3),
    sidePaddingXs: spacing(),
  },
  images: {
    introDefaultImagePath: 'images/vw/introCar.jpg',
    progressImagePath: 'images/vw/car.jpg',
    logo: 'images/vw/logo.jpg',
    favicon: 'favicons/v.ico',
  },
  personalAgreement: {
    backgroundImagePath: personalAgreementBg,
    continueButtonColor: mainColor,
  },
  title: 'VW Bedrijfswagens',
  brandCode: BrandsEnum.VW,
};

export type VWTheme = typeof theme & MUITheme;

export default theme;
